import { FilterResourceType, FiltersApiResponse } from "@/components/PageAllResources/api/interface";
import { fetchAllResourceFiltersAPI } from "@/components/PageAllResources/api";

export const categoryFilterValues = {
  pregnancy: "Pregnancy",
  preconception: "Preconception",
  postpartum: "Postpartum",
  "newborn-and-infant": "New born & Infant",
};

export const fetchFilterData = async (
  category?: string,
  searchParams?: any,
  resourceType?: FilterResourceType,
  pageUrl?: string
): Promise<FiltersApiResponse | {}> => {
  try {
    const queryParams = searchParams
      ? Object.fromEntries(Object.entries(searchParams)?.map(([key, value]: any) => [key, value.split(",")]) || [])
      : {};

    if (category) {
      const categoryName = categoryFilterValues[category];
      queryParams.Category = queryParams?.Category ? [categoryName, ...queryParams?.Category] : [categoryName];
    }

    if (resourceType) {
      queryParams.CollectionType = [resourceType];
    }

    return await fetchAllResourceFiltersAPI(queryParams, pageUrl);
  } catch (e) {
    console.error({ e });

    return {};
  }
};
